<template>
    <portal to="modals">
        <!-- 결제링크 전송 팝업 -->
        <div v-show="show" class="layer-pop square-type" style="z-index: 1001; isolation: isolate">
            <div class="view-content" style="width: 1240px">
                <button class="close" @click="onClosePop"><span class="blind">팝업 닫기</span></button>
                <p class="sub-title px-6 pb-6">결제링크보내기</p>
                <div class="scroll-area com-scroll-y px-6" ref="scrollAreaRef">
                    <div class="com-table-wrap mt-0">
                        <div class="com-card-input half-type p-6 m-0">
                            <div class="left-box pr-6">
                                <div class="line">
                                    <span class="tit">
                                        센터
                                        <span class="imp">*</span>
                                    </span>
                                    <div class="input-cnt">
                                        <select-form
                                            :select-data="[...chainCenterType]"
                                            :select-value="[...chainCenterTypeValue]"
                                            :selected-value="chainCenter"
                                            @update:set="(val) => (chainCenter = val)"
                                        ></select-form>
                                    </div>
                                </div>
                                <div class="line">
                                    <span class="tit">
                                        회원명
                                        <span class="imp">*</span>
                                    </span>
                                    <div class="input-cnt">
                                        <input :value="customerInfo.name" class="w145" readonly type="text" />
                                        <button
                                            :disabled="editableCustomer == false"
                                            class="com-btn"
                                            @click="onClickSearchCustomer"
                                        >
                                            검색
                                        </button>
                                    </div>
                                </div>
                                <div class="line">
                                    <span class="tit">
                                        이용권
                                        <span class="imp">*</span>
                                    </span>
                                    <div class="d-flex align-items-center gap-2 mt-2.5">
                                        <!-- 이용권 신규 등록시 -->
                                        <select-form
                                            :select-data="['전체', ...Object.values(TICKET_TYPES)]"
                                            :select-value="['', ...Object.keys(TICKET_TYPES)]"
                                            class="w145"
                                            @update:set="handleProductTypeSelect"
                                        />
                                        <input v-model="searchProdKeyword" class="flex-1" type="text" />
                                        <button
                                            :disabled="!searchProdKeyword"
                                            class="com-btn m-0"
                                            @click="onClickSearchProd"
                                        >
                                            검색
                                        </button>
                                        <button class="com-search-reset m-0" @click="onResetSearch"></button>
                                    </div>
                                </div>

                                <div class="mt-4">
                                    <table class="com-table">
                                        <colgroup>
                                            <col style="width: 80px" />
                                            <col />
                                            <col style="width: 120px" />
                                            <col style="width: 120px" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>구분</th>
                                                <th>이용권 명</th>
                                                <th>횟수</th>
                                                <th>유효기간</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <perfect-scrollbar style="max-height: 240px">
                                        <table class="com-table">
                                            <colgroup>
                                                <col style="width: 80px" />
                                                <col />
                                                <col style="width: 120px" />
                                                <col style="width: 120px" />
                                            </colgroup>
                                            <tbody>
                                                <tr
                                                    v-for="(t, index) in filteredProdlist"
                                                    :key="index"
                                                    class="pointer select-none"
                                                    :class="
                                                        selectedProd &&
                                                        selectedProd.centerProductId === t.centerProductId
                                                            ? 'selected'
                                                            : ''
                                                    "
                                                    @click="onSelectProduct(t)"
                                                >
                                                    <td>{{ t.type }}</td>
                                                    <td>{{ t.name }}</td>
                                                    <td>{{ t.cntTxt }}</td>
                                                    <td>{{ t.periodTxt }}</td>
                                                </tr>
                                                <tr v-if="filteredProdlist.length === 0">
                                                    <td colspan="100">이용권이 없습니다.</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </perfect-scrollbar>
                                </div>

                                <loading-spinner v-if="productIsLoading"></loading-spinner>
                                <div v-else class="">
                                    <!-- 이용권 정보 -->
                                    <div v-for="(p, index) in addedProdList" :key="index" class="info-box mt-6">
                                        <span class="sub-title d-none">
                                            <template v-if="prodIsT === true">
                                                <!-- 이용권인 경우 -->
                                                {{ getTicketTypeString(addedProdListInfo.ticketType) }}
                                                {{ addedProdListInfo.name }}
                                                {{
                                                    getLessonCntString(addedProdListInfo.lessonCountType, p.lessonCount)
                                                }}
                                            </template>
                                            <template v-if="prodIsP === true">
                                                <!-- 패키지인 경우 -->
                                                {{
                                                    getTicketTypeString(
                                                        addedProdListInfo.packageCenterProducts[index].ticketType
                                                    )
                                                }}
                                                {{ addedProdListInfo.packageCenterProducts[index].name }}
                                                {{
                                                    getLessonCntString(
                                                        addedProdListInfo.packageCenterProducts[index].lessonCountType,
                                                        addedProdListInfo.packageCenterProducts[index].lessonCount
                                                    )
                                                }}
                                            </template>
                                        </span>
                                        <div class="line">
                                            <span class="tit">
                                                유효기간
                                                <span class="imp">*</span>
                                            </span>
                                            <div class="input-cnt">
                                                <div class="com-calendar-wrap">
                                                    <single-calendar
                                                        :id="p.centerProductId"
                                                        :start-date="p.expireStartDt"
                                                        @change="changeExpireDate"
                                                    ></single-calendar>
                                                    <div class="com-dash"><span class="dash">~</span></div>
                                                    <single-calendar
                                                        :end-date="p.expireEndDt"
                                                        @update="(val) => (p.expireEndDt = val)"
                                                    ></single-calendar>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="line d-flex gap-4">
                                            <div class="flex-1">
                                                <span class="tit">정상가</span>
                                                <div class="input-cnt">
                                                    <input
                                                        class="w220"
                                                        readonly
                                                        type="text"
                                                        v-bind:value="getNumberFormat(p.productOrgPrice)"
                                                    />
                                                    <span class="txt">원</span>
                                                </div>
                                            </div>
                                            <div class="flex-1">
                                                <span class="tit">
                                                    실제구매가
                                                    <span class="imp">*</span>
                                                    <div class="com-tooltip">
                                                        <button class="icon"></button>
                                                        <div class="detail">
                                                            <span class="tit">실제구매가</span>
                                                            <p class="txt">
                                                                정상가와 실제 구매가의 가격이 다를 경우 변경할 수
                                                                있습니다.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </span>
                                                <div class="input-cnt">
                                                    <input
                                                        class="w220"
                                                        maxlength="12"
                                                        type="text"
                                                        v-bind:value="getNumberFormat(p.productBuyPrice)"
                                                        @keypress="isNumber($event)"
                                                        v-on:keyup="onKeyupProdBuyPrice($event, index)"
                                                    />
                                                    <span class="txt">원</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="line d-flex gap-4">
                                            <div class="flex-1">
                                                <span class="tit">
                                                    횟수
                                                    <span class="imp">*</span>
                                                    &nbsp;
                                                    <span
                                                        v-if="checkAllowedCount(p.lessonCount, p.lessonCountType)"
                                                        class="red"
                                                    >
                                                        {{ countMessage }}
                                                    </span>
                                                </span>
                                                <div class="input-cnt">
                                                    <span class="txt">{{ getLessonCntType(p.lessonCountType) }}</span>
                                                    <span v-if="!isInfinity(index, p)">
                                                        <input
                                                            v-model="p.lessonCount"
                                                            :disabled="p.lessonCountType === 'W'"
                                                            class="w70"
                                                            maxlength="3"
                                                            type="text"
                                                            @keypress="isNumber($event)"
                                                        />
                                                        <span class="txt">회</span>
                                                    </span>
                                                    <div class="com-tooltip">
                                                        <button class="icon"></button>
                                                        <div class="detail">
                                                            <span class="tit">횟수</span>
                                                            <p class="txt">
                                                                총 횟수 변경 시, 1회당 단가(실제 구매가/횟수)가 변경되며
                                                                %급여 정산에 영향을 미칠 수 있습니다.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex-1">
                                                <span class="tit">수업시간</span>
                                                <div class="input-cnt">
                                                    <template v-if="prodIsT === true">
                                                        <!-- 이용권인 경우 -->
                                                        <select-form
                                                            :select-data="['0', '0.5', '1', '1.5', '2']"
                                                            :select-value="[0, 30, 60, 90, 120]"
                                                            :selected-value="
                                                                addedProdListInfo.lessonTime === null
                                                                    ? 0
                                                                    : addedProdListInfo.lessonTime
                                                            "
                                                            class="w70"
                                                            disabled
                                                        ></select-form>
                                                    </template>
                                                    <template v-else-if="prodIsP === true">
                                                        <!-- 패키지인 경우 -->
                                                        <select-form
                                                            :select-data="['0', '0.5', '1', '1.5', '2']"
                                                            :select-value="[0, 30, 60, 90, 120]"
                                                            :selected-value="
                                                                addedProdListInfo.packageCenterProducts[index]
                                                                    .lessonTime === null
                                                                    ? 0
                                                                    : addedProdListInfo.packageCenterProducts[index]
                                                                          .lessonTime
                                                            "
                                                            class="w70"
                                                            disabled
                                                        ></select-form>
                                                    </template>
                                                    <span class="txt">시간</span>
                                                    <div class="com-tooltip">
                                                        <button class="icon"></button>
                                                        <div class="detail">
                                                            <span class="tit">시간</span>
                                                            <p class="txt">
                                                                회원과 1회당 진행하는 이용권시간입니다. 설정한 시간이
                                                                스케줄표에 적용됩니다.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <template v-if="prodIsT === true">
                                                        <!-- 이용권인 경우 -->
                                                        <select-form
                                                            :select-data="['0', '0.5', '1', '1.5', '2']"
                                                            :select-value="['0', '0.5', '1.0', '1.5', '2.0']"
                                                            :selected-value="
                                                                addedProdListInfo.lessonPerLessonCount === null
                                                                    ? '0'
                                                                    : addedProdListInfo.lessonPerLessonCount
                                                            "
                                                            class="w70"
                                                            disabled
                                                        ></select-form>
                                                    </template>
                                                    <template v-else-if="prodIsP === true">
                                                        <!-- 패키지인 경우 -->
                                                        <select-form
                                                            :select-data="['0', '0.5회', '1', '1.5', '2']"
                                                            :select-value="['0', '0.5', '1.0', '1.5', '2.0']"
                                                            :selected-value="
                                                                addedProdListInfo.packageCenterProducts[index]
                                                                    .lessonPerLessonCount === null
                                                                    ? '0'
                                                                    : addedProdListInfo.packageCenterProducts[index]
                                                                          .lessonPerLessonCount
                                                            "
                                                            class="w70"
                                                            disabled
                                                        ></select-form>
                                                    </template>
                                                    <span class="txt">회</span>
                                                    <div class="com-tooltip">
                                                        <button class="icon mr-0"></button>
                                                        <div class="detail">
                                                            <span class="tit">회</span>
                                                            <p class="txt">
                                                                직원의 월말정산 시, 한 달 총 수업횟수를 합산할 때,
                                                                수업시간에 따라 몇회로 인정할 지 설정합니다.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="line">
                                            <span class="tit">
                                                매출직원
                                                <span class="imp">*</span>
                                                <div class="com-tooltip">
                                                    <button class="icon"></button>
                                                    <div class="detail">
                                                        <span class="tit">매출직원</span>
                                                        <p class="txt">
                                                            월별정산에서 신규매출/재등록매출/매출인센티브를 계산할 때,
                                                            최초 선택된 직원에게 적용됩니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                            <div class="input-cnt">
                                                <select-form
                                                    :select-data="['선택안함', ...centerStaffList]"
                                                    :select-value="[null, ...centerStaffValueList]"
                                                    :selected-value="p.saleStaffId"
                                                    class="w220"
                                                    @update:set="(val) => (p.saleStaffId = val)"
                                                ></select-form>
                                                <div class="com-radio">
                                                    <input
                                                        :id="`radio-s1-1-${index}`"
                                                        v-model="p.saleStaffContractType"
                                                        :name="`radio-s1-${index}`"
                                                        type="radio"
                                                        value="N"
                                                    />
                                                    <label :for="`radio-s1-1-${index}`">신규</label>
                                                </div>
                                                <div class="com-radio">
                                                    <input
                                                        :id="`radio-s1-2-${index}`"
                                                        v-model="p.saleStaffContractType"
                                                        :name="`radio-s1-${index}`"
                                                        type="radio"
                                                        value="R"
                                                    />
                                                    <label :for="`radio-s1-2-${index}`">재등록</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="line">
                                            <span class="tit">
                                                담당강사
                                                <span class="imp">*</span>
                                                <div class="com-tooltip">
                                                    <button class="icon"></button>
                                                    <div class="detail">
                                                        <span class="tit">담당강사</span>
                                                        <p class="txt">
                                                            월별정산에서 신규/재등록 이용권 수를 계산할 때 최초 선택된
                                                            담당강사에게 적용됩니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </span>
                                            <div class="input-cnt">
                                                <select-form
                                                    :select-data="['선택안함', ...centerStaffList]"
                                                    :select-value="[null, ...centerStaffValueList]"
                                                    :selected-value="p.lessonStaffId"
                                                    class="w220"
                                                    @update:set="(val) => (p.lessonStaffId = val)"
                                                ></select-form>
                                                <div class="com-radio">
                                                    <input
                                                        :id="`radio-s2-1-${index}`"
                                                        v-model="p.lessStaffContractType"
                                                        :name="`radio-s2-${index}`"
                                                        type="radio"
                                                        value="N"
                                                    />
                                                    <label :for="`radio-s2-1-${index}`">신규</label>
                                                </div>
                                                <div class="com-radio">
                                                    <input
                                                        :id="`radio-s2-2-${index}`"
                                                        v-model="p.lessStaffContractType"
                                                        :name="`radio-s2-${index}`"
                                                        type="radio"
                                                        value="R"
                                                    />
                                                    <label :for="`radio-s2-2-${index}`">재등록</label>
                                                </div>
                                            </div>
                                            <div class="sub-line">
                                                <div class="com-check">
                                                    <input
                                                        :id="`check-s1-1-${index}`"
                                                        v-model="p.lessonResverStaffYn"
                                                        name="check-1"
                                                        type="checkbox"
                                                    />
                                                    <label :for="`check-s1-1-${index}`">
                                                        회원APP에서 지정된 강사에게만 예약 가능
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            v-if="
                                                addedProdListInfo.ticketType == 'P' ||
                                                addedProdListInfo.ticketType == 'O'
                                            "
                                            class="line"
                                        >
                                            <span class="tit">
                                                1회 당 정산금액
                                                <small>(필요할 경우에만 입력)</small>
                                            </span>
                                            <div class="input-cnt">
                                                <input
                                                    class="w220"
                                                    maxlength="12"
                                                    placeholder="필요 시 입력"
                                                    type="text"
                                                    v-bind:value="
                                                        p.turnBillPrice !== null ? getNumberFormat(p.turnBillPrice) : ''
                                                    "
                                                    @input="onKeyupTurnBillPrice($event, index)"
                                                    @keypress="isNumber($event)"
                                                />
                                                <span class="txt">원</span>
                                                <div class="com-tooltip">
                                                    <button class="icon"></button>
                                                    <div class="detail">
                                                        <span class="tit">1회 당 정산금액</span>
                                                        <p class="txt">
                                                            해당 이용권만 별도의 정산금액 적용을 원할 경우 입력합니다.
                                                            강사에게 설정된 기본 급여설정 보다 우선 적용됩니다.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-end mt-6">
                                    <button
                                        class="com-btn blue"
                                        :disabled="!addedProdList.length"
                                        @click="moveProdToRight"
                                    >
                                        이용권 추가
                                    </button>
                                </div>
                            </div>
                            <div class="right-box pl-6">
                                <p class="fs-4.5">선택한 이용권</p>
                                <div v-for="(g, gidx) in completedProdList" :key="gidx">
                                    <div v-for="(p, index) in g.prodList" :key="index" class="prod-card mt-6">
                                        <div class="card-cont">
                                            <div class="flex-1">
                                                <p class="card-tit">
                                                    <template v-if="g.prodType === 'T'">
                                                        <!-- 이용권인 경우 -->
                                                        {{ g.info.name }}
                                                    </template>
                                                    <template v-if="g.prodType === 'P'">
                                                        <!-- 패키지인 경우 -->
                                                        {{ g.info.packageCenterProducts[index].name }}
                                                    </template>
                                                </p>
                                                <p class="text-muted">
                                                    <span>
                                                        <template v-if="g.prodType === 'T'">
                                                            <!-- 이용권인 경우 -->
                                                            {{
                                                                getLessonCntString(
                                                                    g.info.lessonCountType,
                                                                    p.lessonCount
                                                                )
                                                            }}
                                                        </template>
                                                        <template v-if="g.prodType === 'P'">
                                                            <!-- 패키지인 경우 -->
                                                            {{
                                                                getLessonCntString(
                                                                    g.info.packageCenterProducts[index].lessonCountType,
                                                                    g.info.packageCenterProducts[index].lessonCount
                                                                )
                                                            }}
                                                        </template>
                                                    </span>
                                                    <span>/</span>
                                                    <span>{{ p.expireStartDt }} ~ {{ p.expireEndDt }}</span>
                                                </p>
                                            </div>
                                            <div>
                                                <span class="price">{{ getNumberFormat(p.productBuyPrice) }}</span>
                                                원
                                            </div>
                                        </div>
                                        <button class="card-del" @click="onRemoveSelection(gidx)"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="onClosePop">취소</button>
                        <button
                            class="com-btn blue"
                            :disabled="!completedProdList.length"
                            @click="onClickRegistContract"
                        >
                            결제링크 전송
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </portal>
</template>

<script>
import moment from 'moment';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import { Utils } from '@/assets/js/utils';
import { validateNumber } from '@/assets/js/validation';
import { pagingInfo, TICKET_TYPES } from '@/assets/js/common';

export default {
    name: 'PaymentLinkDlg',
    components: { PerfectScrollbar, LoadingSpinner },
    props: {
        customerId: String,
        show: Boolean,
        close: Function,
        change: Function,
        searchCustomer: Function,
    },
    computed: {
        prodIsT() {
            // 선택된 상품이 이용권이면 true
            return this.addedProdListInfo.productType === 'T';
        },
        prodIsP() {
            return this.addedProdListInfo.productType === 'P';
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
        totalProductCount() {
            // 이용권 개수 합계
            return this.completedProdList.length;
        },
        totalOrgPrice() {
            // 정상가 합계
            let price = 0;
            this.completedProdList.forEach((p) => (price += this.getPureNumber(p.productOrgPrice)));
            return this.getNumberFormat(price);
        },
        totalBuyPrice() {
            // 실제구매가 합계
            let price = 0;
            this.completedProdList.forEach((p) => (price += this.getPureNumber(p.productBuyPrice)));
            return this.getNumberFormat(price);
        },
        totalValidBuyPrice() {
            let price = 0;
            this.addedProdList.forEach((p) => (price += this.getPureNumber(p.productBuyPrice)));
            return this.getNumberFormat(price);
        },
        /*
    고객 요구에 의해서 삭제
    totalLessonCount() { // 이용권 횟수 합계
        let count = 0;
        this.addedProdList.forEach((p) => count += parseInt(p.lessonCount));
        return count;
    },
    */
        totalBillPrice() {
            // 결제 금액 합계
            let billPrice = 0;
            this.editField.bills.forEach((b) => {
                billPrice += b.billPrice;
                // if(b.hasOwnProperty('spendMileage')){
                //     billPrice += b.spendMileage;
                // }
            });
            return billPrice;
        },
        totalDebtPrice() {
            // 미수 금액 합계
            let debtPrice = 0;
            debtPrice = this.getPureNumber(this.totalBuyPrice) - this.getPureNumber(this.totalBillPrice);

            return this.getNumberFormat(debtPrice);
        },
        today() {
            // 오늘 날짜 반환
            return moment().format('YYYY-MM-DD');
        },
        centerChains() {
            // 체인 목록 [본점, 지점, 지점...] (체인점 최고권한자만 값이 있음)
            const { getters } = this.$store;
            return getters['auth/centerChains'];
        },
        memo() {
            const m = this.contractId ? this.addedProdListInfo.memo : this.editField.memo;
            return m || '';
        },
        editableCustomer() {
            return !!this.searchCustomer;
        },
    },
    created() {
        this.TICKET_TYPES = TICKET_TYPES;
        this.MEMO_MAX_LEN = 1000;
    },
    watch: {
        customerId(v) {
            if (v) {
                this.fetchCustomerDetail(v);
            } else {
                this.customerInfo = {};
            }
        },
    },
    mounted() {
        this.chainCenter = parseInt(this.cId);
        this.init();
    },
    data() {
        return {
            userPop: false,
            isLoading: false, // 페이지 로딩
            productIsLoading: false, // 이용권 로딩
            selectedProdType: '',
            selectedProd: '', // 선택된 이용권

            searchProdKeyword: '', // 이용권 검색어
            centerProdInfo: [], // 센터 상품 목록 (이용권)
            filteredProdlist: [],

            completedProdListInfo: {}, // 추가된 이용권 목록 (가공 전)
            completedProdList: [], // 추가된 이용권 목록 (가공 후)
            completedProductType: '', // 추가된 이용권 타입 (T : 이용권, P : 패키지)

            addedProdListInfo: {}, // 추가된 이용권 목록 (가공 전)
            addedProdList: [], // 추가된 이용권 목록 (가공 후)
            addedProductType: '', // 추가된 이용권 타입 (T : 이용권, P : 패키지)

            centerChainList: [], // 본점 + 지점 체인점 목록
            customerInfo: {}, // 회원 정보
            editField: {
                regStaffId: '',
                bills: [],
            },

            searchCustomerStr: '', // 회원 검색 키워드
            searchCustomerList: [], // 검색된 회원 목록
            pickedCustomerId: '', // 선택한 회원의 customerId
            pagingInfo: { ...pagingInfo }, // 회원 검색 팝업 페이징 파라미터

            centerStaffList: [], // centerStaff 이름 목록
            centerStaffValueList: [], // centerStaff ID 목록

            chainCenterType: [], // 체인 센터명 배열
            chainCenterTypeValue: [], // 체인 센터 Id 배열
            chainCenter: '',

            periodInfoList: [], // 유효 기간 정보들의 목록

            // 마일리지 설정 정보
            mileageInfo: {},

            returnYn: false,
            countMessage: '',
        };
    },

    methods: {
        // 센터 상품 목록 fetch
        async fetchCenterProdList() {
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}/product/ticket/all`);
                this.centerProdInfo = data;

                this.arrangeProdInfo(this.centerProdInfo); // 받아온 이용권 목록을 변수에 셋팅
            } catch (error) {
                alert('이용권 목록을 불러오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 초기화
        async init() {
            this.isLoading = true;
            this.centerId = parseInt(this.cId); // 로그인한 센터 id
            this.centerChainList = this.centerChains; // 체인점 최고 관리자는 centerChains 에 본점 + 지점 목록이 있음
            await this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            await this.getMileageInfo();
            if (this.centerChainList == undefined) {
                // 체인리스트가 없을때는 아무것도 하지 않는데 에러발생
            } else if (this.centerChainList.length === 0) {
                // 체인점 최고 관리자가 아닌 일반 센터 관리자 및 직원일 경우 접속한 아이디에 해당하는 센터만 센터 목록에 보임
                this.chainCenterType.push(this.centerInfo.centerName);
                this.chainCenterTypeValue.push(this.centerInfo.id);
                this.centerId = this.centerInfo.id;
            } else if (this.centerChainList.length !== 0) {
                // 체인점 최고 권한자일 경우 체인점에 속한 모든 센터가 목록에 보임
                this.centerChainList.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.centerId);
                    this.centerId = this.centerInfo.id; // 접속한 centerId가 기본으로 선택 되게끔 함
                });
            }

            if (this.customerId) {
                // 이미 등록된 회원일 경우 customerId가 있음
                await this.fetchCustomerDetail(this.customerId); // customerId로 customer 정보 가져오기
            }
            await this.fetchCenterProdList(); // 센터 이용권 목록 가져오기

            await this.fetchCenterStaffList(); // 매출직원, 담당강사 목록 가져오기
            // await this.fetchChainCenter(); // 체인점 대표일 경우 센터 목록 가져오기
            this.isLoading = false;
            this.editField.regStaffId = Number(this.centerStaffId);
        },

        scrollToElement() {
            const el = this.$refs.scrollAreaRef;

            if (el) {
                el.scrollTop = 600;
            }
        },

        // 받아온 센터 상품 목록으로 select-form에 나타내기 위해 정리
        arrangeProdInfo(data) {
            // 상품 유형 코드(productType) - T : 이용권(Ticket),  P : 패키지(Package), L : 락커, C : 트레이닝복, S : 부가상품(Sub Product)
            // 이용권_유형_코드(ticketType) - P : 개인,  O : OT,  D : 듀엣,  G : 그룹,  C : 쿠폰,  T : 회원권
            // 수업_횟수_유형_코드(lessonCountType) - T : 총횟수(Total),  W : 주당횟수(Week),  U : 무제한(Unlimit)
            //
            // '[이용권구분] 이용권명' 또는
            // '[패키지] 패키지명' 으로 불러온다.
            //
            //  노출 순서는
            // [이용권 구분] 회원권>개인>OT>듀엣>그룹>쿠폰>패키지 순이다.
            // 이용권 구분 후 이용권명 ㄱㄴㄷ 순이다.

            const types = Object.keys(TICKET_TYPES);
            this.filteredProdlist.splice(0);

            this.filteredProdlist = data
                .filter((prod) => {
                    if (!prod.stockUseYn) {
                        return false;
                    }

                    if (this.selectedProdType && prod.ticketType !== this.selectedProdType) {
                        return false;
                    }

                    if (this.searchProdKeyword && !prod.name.includes(this.searchProdKeyword)) {
                        return false;
                    }

                    return true;
                })
                .map((prod) => {
                    const { ticketType, lessonCountType, lessonCount, periodType, periodCount, ...rest } = prod;
                    const cntTxt =
                        lessonCountType === 'T' || lessonCountType === 'W'
                            ? `${lessonCountType === 'W' ? '주' : ''}${lessonCount}회`
                            : '-';
                    const periodTxt = periodType
                        ? `${periodCount}${periodType === 'M' ? '개월' : ''}${periodType === 'D' ? '일' : ''}`
                        : '-';

                    return {
                        ticketType,
                        type: TICKET_TYPES[ticketType],
                        cntTxt,
                        periodTxt,
                        ...rest,
                    };
                })
                .sort((a, b) => {
                    const a_order = types.indexOf(a.ticketType);
                    const b_order = types.indexOf(b.ticketType);

                    if (a_order < b_order) return -1;
                    if (a_order > b_order) return 1;

                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;

                    return 0;
                });
        },

        onClickSearchProd() {
            // 이용권 검색버튼 클릭
            this.arrangeProdInfo(this.centerProdInfo);
        },

        onResetSearch() {
            this.searchProdKeyword = '';
            this.arrangeProdInfo(this.centerProdInfo);
        },

        moveProdToRight() {
            const validate = this.validateValues();
            if (!validate.result) {
                alert(validate.msg);
                return false;
            }

            if (this.completedProdList.length >= 3) {
                alert('선택가능한 이용권은 최대 3개입니다.');
                return;
            }

            const prodList = [...this.addedProdList];
            const info = { ...this.addedProdListInfo };
            this.completedProdList.push({
                prodList,
                info,
                prodType: this.addedProductType,
            });

            this.addedProdListInfo = {};
            this.addedProdList = [];
            this.addedProductType = '';
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}`);
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 이용권 등록 버튼 클릭시
        async onClickRegistContract() {
            try {
                if (!confirm('URL결제요청을 하시겠습니까?')) {
                    return false;
                }

                this.isLoading = true;
                const { data } = await this.sendPostRegistContract();
                alert(
                    '이용권이 등록 되었습니다.\n 회원님에게 URL결제요청 하였습니다.\n 회원님이 결제를 완료하면 결제정보가 자동으로 등록됩니다.'
                );
                this.isLoading = false;
                this.handleResetProd();
                if (this.change) {
                    this.change();
                }
                this.close();
            } catch (error) {
                alert('URL결제요청 실패 하였습니다.');
                this.isLoading = false;
            }
        },

        handleResetProd() {
            this.completedProdList = [];

            this.addedProdList = [];
            this.addedProdListInfo = {};
            this.addedProductType = '';
        },

        onClosePop() {
            this.handleResetProd();
            this.close();
        },

        // 스웨거 검색: 센터회원계약 등록
        sendPostRegistContract() {
            const params = this.getRegistParams();
            if (params) {
                return api.post(`/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/list`, {
                    ...params,
                });
            }
        },

        // 센터회원계약 등록 파라미터 가공
        getRegistParams() {
            const { editField, completedProdList } = this;

            const list = [];

            for (let i = 0; i < completedProdList.length; i++) {
                const { prodList, info } = completedProdList[i];

                const totalSpendMileage = 0; // 마일리지 사용 금액 총합
                const totalEtcPrice = 0; // 기타 할인 금액 총합
                let totalBuyPrice = 0,
                    totalOrgPrice = 0;
                const products = [];

                prodList.forEach((p) => {
                    // 이용권 목록 가공
                    const temp = {
                        centerProductId: this.getPureNumber(p.centerProductId),
                        centerProductVersion: this.getPureNumber(p.centerProductVersion),
                        productOrgPrice: this.getPureNumber(p.productOrgPrice),
                        productBuyPrice: this.getPureNumber(p.productBuyPrice),
                        saleStaffId: p.saleStaffId || null,
                        saleStaffContractType: p.saleStaffContractType,
                        lessonStaffId: p.lessonStaffId,
                        lessStaffContractType: p.lessStaffContractType,
                        expireStartDt: p.expireStartDt,
                        expireEndDt: p.expireEndDt,
                        lessonCountType: p.lessonCountType,
                        lessonCount: this.getPureNumber(p.lessonCount),
                        turnBillPrice: this.getPureNumber(p.turnBillPrice),
                        lessonResverStaffYn: p.lessonResverStaffYn,
                    };
                    if (Utils.isEmpty(this.getPureNumber(p.turnBillPrice))) {
                        delete temp.turnBillPrice;
                    }
                    // if (Utils.isEmpty(p.saleStaffId)) {
                    //   delete temp.saleStaffId;
                    // }
                    if (Utils.isEmpty(p.lessonStaffId)) {
                        delete temp.lessonStaffId;
                    }

                    totalBuyPrice += p.productBuyPrice;
                    totalOrgPrice += p.productOrgPrice;

                    products.push(temp);
                });

                const bills = [
                    {
                        debtYn: false,
                        billSeq: 0,
                        buyDate: moment().format('YYYY-MM-DD'),
                        billPrice: 0,
                        payType: 'U',
                        mileage: 0,
                        npReqPrice: this.getPureNumber(totalBuyPrice),
                    },
                ];

                const param = {
                    contractType: 'N', // 계약 유형 코드 (신규계약 : N, 재등록 : R, 환불 : C)
                    productType: info.productType, // 구매상품 유형 코드 (이용권 : T, 패키지 : P, 락커 : L, 부가상품 : S)
                    totalProductCount: completedProdList.length, // 전체상품갯수
                    totalOrgPrice: this.getPureNumber(totalOrgPrice), // 전체정상가격
                    totalBuyPrice: this.getPureNumber(totalBuyPrice), // 전체실구매가격
                    regStaffId: parseInt(editField.regStaffId), // 입력자직원아이디
                    mileageUsePrice: totalSpendMileage, // 마일리지 사용금액
                    etcDiscountPrice: totalEtcPrice, // 기타 할인금액
                    retunYn: 'N', // 환불 여부
                    centerProductId: this.getPureNumber(info.centerProductId), // 센터상품아이디
                    centerProductVersion: this.getPureNumber(info.centerProductVersion), // 센터상품버젼
                    totalDebtPrice: this.getPureNumber(totalBuyPrice), // 전체 미수금
                    memo: editField.memo, // 메모
                    products, // 센터회원 계약 상품
                    bills, // 센터회원 계약 결제정보
                };

                list.push(param);
            }

            return { list };
        },

        // 파라미터 validate
        validateValues() {
            // 필수값 체크
            let result = false;
            const { editField, centerId, customerId } = this;
            let msg = '';

            // 센터
            if (centerId === '' || centerId === undefined) {
                msg = '센터를 선택하세요.';
                return { result, msg };
            }

            // 회원명
            if (customerId === '') {
                msg = '회원을 선택하세요.';
                return { result, msg };
            }

            // 이용권
            if (this.addedProdList.length === 0) {
                msg = '이용권을 선택하세요.';
                return { result, msg };
            }

            // 입력자 editField.regStaffId -> this.centerStaffId 로처리

            // 횟수
            if (this.countMessage === '예약되어있는 횟수 보다 낮은 값을 넣을 수 없습니다.') {
                msg = '예약되어있는 횟수 보다 낮은 값을 넣을 수 없습니다.';
                return { result, msg };
            }

            // 추가된 이용권들의 유효기간, 실제구매가, 매출직원, 담당강사 체크
            this.addedProdList.some((p, index) => {
                if (Utils.isEmpty(p.expireStartDt) || Utils.isEmpty(p.expireEndDt)) {
                    msg = `${index + 1}번째 이용권의 유효기간을 선택하세요.`;
                    return true;
                }

                if (Utils.isEmpty(p.productBuyPrice)) {
                    msg = `${index + 1}번째 이용권의 실제구매가를 입력하세요.`;
                    return true;
                } else if (!validateNumber(this.getPureNumber(p.productBuyPrice))) {
                    msg = `${index + 1}번째 이용권의 실제구매가를 다시 입력하세요.`;
                    return true;
                }

                if (Utils.isEmpty(p.lessonCount)) {
                    // p.lessonCount === 0 || p.lessonCount === '0'
                    msg = `${index + 1}번째 이용권의 횟수를 입력하세요.`;
                    return true;
                } else if (!validateNumber(p.lessonCount)) {
                    msg = `${index + 1}번째 이용권의 횟수를 다시 입력하세요.`;
                    return true;
                }

                if (p.turnBillPrice && !validateNumber(this.getPureNumber(p.turnBillPrice))) {
                    msg = `${index + 1}번째 이용권의 1회당 정산금액을 다시 입력하세요.`;
                    return true;
                }
            });

            // 미수금액 체크
            if (this.getPureNumber(this.totalValidBuyPrice) <= 0) {
                msg = '결제금액을 입력해주세요.';
            }

            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },

        // 매출직원, 담당강사 목록 가져오기
        async fetchCenterStaffList() {
            try {
                this.centerStaffList = [];
                this.centerStaffValueList = [];
                const { data } = await api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
                data.forEach((d) => {
                    this.centerStaffList.push(d.name);
                    this.centerStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            let centerId;
            this.chainCenter === '' ? (centerId = this.centerId) : (centerId = this.chainCenter);
            return api.get(`/admin/api/center/${centerId}/chain`);
        },

        // 센터 회원 기본 정보 가져오기
        async fetchCustomerDetail(customerId) {
            try {
                const { data } = await this.sendGetCustomerDetail(customerId);
                this.customerInfo = data || {}; // 가져온 그대로 customerInfo에 넣기
            } catch (error) {
                alert('회원 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 기본 정보 조회 API 호출
        sendGetCustomerDetail(customerId) {
            return api.get(`/admin/api/center/${this.centerId}/customer/${customerId}`);
        },

        // 이용권 유형 코드 변환
        getTicketTypeString(ticketType) {
            let str = '';
            switch (ticketType) {
                case 'P': // 개인
                    str = '[개인]';
                    break;
                case 'O': // OT
                    str = '[OT]';
                    break;
                case 'D': // 듀엣
                    str = '[듀엣]';
                    break;
                case 'G': // 그룹
                    str = '[그룹]';
                    break;
                case 'C': // 쿠폰
                    str = '[쿠폰]';
                    break;
                case 'T': // 회원권
                    str = '[회원권]';
                case 'S': // 운동복
                    str = '[운동복]';
                    break;
            }
            return str;
        },

        // 수업 횟수 유형 변환
        getLessonCntString(lessonCountType, lessonCount) {
            let str = '';
            switch (lessonCountType) {
                case 'T': // 총횟수
                    str = `${lessonCount}회`;
                    break;
                case 'W': // 주당횟수
                    str = `주 ${lessonCount}회`;
                    break;
                case 'U': // 무제한
                    str = '';
                    break;
            }
            return str;
        },

        // 수업 유형 변환
        getLessonCntType(lessonCountType) {
            let str = '';
            switch (lessonCountType) {
                case 'T':
                    str = '총 ';
                    break;
                case 'W':
                    str = '주 ';
                    break;
                default:
                    str = '무제한';
                    break;
            }
            return str;
        },

        // 센터 상품 목록 조회 API
        sendGetCenterProdList() {
            // 스웨거 검색: 티켓/패키지 상품 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/product/ticket/all`);
        },

        // 회원명 검색 버튼 클릭시
        onClickSearchCustomer() {
            if (this.searchCustomer) {
                this.searchCustomer();
            }
            // this.userPop = true;
            // this.$nextTick(function() {
            //   this.$refs.refCustomerName.focus();
            // });
        },

        // 회원명으로 회원 검색
        async onSearchCustomer() {
            try {
                const { data } = await this.sendGetCustomer();
                this.setPageParams(data);
                this.searchCustomerList = data.items;
            } catch (error) {
                alert('회원 검색 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 페이징 목록 조회
        sendGetCustomer() {
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    ...this.pagingInfo,
                    searchStr: this.searchCustomerStr,
                },
            });
        },

        // 회원 검색 팝업 취소 버튼 클릭시
        onClickCancleSearchPop() {
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },

        // 페이징 파라미터 저장
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 센터 회원 검색 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchCustomer();
        },

        // select-form 이용권 선택시 이벤트
        async handleProductTypeSelect(val) {
            this.selectedProdType = val;
            this.arrangeProdInfo(this.centerProdInfo);
            this.selectedProd = '';
        },

        // 이용권 선택시 이벤트
        async onSelectProduct(prod) {
            if (!prod) return;

            this.selectedProd = prod;
            await this.fetchProduct(prod.centerProductId);

            this.scrollToElement();
        },

        onRemoveSelection(gidx) {
            const list = [...this.completedProdList];
            list.splice(gidx, 1);

            this.completedProdList = list;
        },

        // product id로 센터상품 조회
        async fetchProduct(productId) {
            try {
                if (productId === '') {
                    return;
                }
                this.productIsLoading = true;
                // 추가된 이용권, 패키지 초기화
                this.addedProdListInfo = {};
                this.addedProdList = [];
                this.periodInfoList = [];

                const { data } = await this.sendGetProduct(productId);
                this.addedProdListInfo = data;
                if (data.productType === 'P') {
                    // 추가한 상품이 패키지일 경우
                    this.addedProductType = 'P';
                    data.packageCenterProducts.forEach((p) => {
                        const temp = {
                            centerProductId: p.centerProductId,
                            centerProductVersion: p.centerProductVersion,
                            productOrgPrice: this.getNumberFormat(p.recvPrice),
                            productBuyPrice: this.getNumberFormat(p.sellPrice, this.addedProdListInfo.vatYn),
                            saleStaffId: null,
                            saleStaffContractType: 'N',
                            lessonStaffId: null,
                            lessStaffContractType: 'N',
                            expireStartDt: moment().format('YYYY-MM-DD'),
                            expireEndDt:
                                p.periodType === 'M'
                                    ? moment().add(p.periodCount, 'month').subtract(1, 'days').format('YYYY-MM-DD')
                                    : moment().add(p.periodCount, 'day').format('YYYY-MM-DD'),
                            lessonCount: p.lessonCount,
                            lessonCountType: p.lessonCountType,
                            turnBillPrice: '',
                            lessonResverStaffYn: false,
                        };
                        this.addedProdList.push(temp);
                    });
                } else if (data.productType === 'T') {
                    this.addedProductType = 'T';
                    const temp = {
                        centerProductId: data.centerProductId,
                        centerProductVersion: data.centerProductVersion,
                        // contractProductSeq: this.addedProdListInfo.length,
                        productOrgPrice: this.getNumberFormat(data.recvPrice),
                        productBuyPrice: this.getNumberFormat(data.sellPrice, this.addedProdListInfo.vatYn),
                        saleStaffId: null,
                        saleStaffContractType: 'N',
                        lessonStaffId: null,
                        lessStaffContractType: 'N',
                        expireStartDt: moment().format('YYYY-MM-DD'),
                        expireEndDt:
                            data.periodType === 'M'
                                ? moment().add(data.periodCount, 'month').subtract(1, 'days').format('YYYY-MM-DD')
                                : moment().add(data.periodCount, 'day').subtract(1, 'days').format('YYYY-MM-DD'),
                        lessonCount: data.lessonCount,
                        lessonCountType: data.lessonCountType,
                        turnBillPrice: '',
                        lessonResverStaffYn: false,
                    };
                    this.addedProdList.push(temp);
                }
                this.productIsLoading = false;
            } catch (error) {
                alert('센터 상품 조회 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터상품 조회 API 호출
        sendGetProduct(productId) {
            return api.get(`/admin/api/center/${this.centerId}/product/${productId}`);
        },

        // 금액에 , 넣기
        getNumberFormat(num, vatYn) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            if (vatYn) {
                num = parseInt(parseInt(num) * 1.1);
                return num.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return num.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        // 금액에 , 빼기
        getPureNumber(str) {
            if (typeof str !== 'string' || str === undefined || str === '') {
                return str;
            }
            return parseInt(str.toString().replace(/[^\d]+/g, ''));
        },

        // 숫자 이외 입력 방지
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (!(charCode >= 48 && charCode <= 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // 실제구매가 수정시
        onKeyupProdBuyPrice(e, index) {
            if (e.target.value === '') {
                return;
            }
            const num = this.getPureNumber(e.target.value);
            this.addedProdList[index].productBuyPrice = this.getNumberFormat(num);
            /* 고객 요청에 의해서 해당 기능 삭제
      if(this.getPureNumber(this.addedProdList[index].productOrgPrice) < this.getPureNumber(e.target.value)) { // 정상가 보다 크면 alert 띄움
          alert('실제구매가가 정상가보다 큽니다.');
      }
      */
        },

        // 1회 당 정산금액 수정시
        onKeyupTurnBillPrice(e, index) {
            if (e.target.value === '') {
                return;
            }
            const num = this.getPureNumber(e.target.value);
            this.addedProdList[index].turnBillPrice = this.getNumberFormat(num);
        },

        // 이용권의 유효기간의 시작일을 변경할 때, 종료일도 유효기간에 따라 자동적으로 변경해주는 함수
        changeExpireDate(expireStartDt, centerProductId) {
            const { periodString, periodCount } = this.getPeriodInfo(centerProductId);
            // const expireEndDt = moment(expireStartDt).add(periodCount, periodString).format('YYYY-MM-DD');

            const expireEndDtMoment = moment(expireStartDt).add(periodCount, periodString);
            expireEndDtMoment.subtract(1, 'days');
            /*
      if (periodString === 'month') {
        expireEndDtMoment.subtract(1, 'days');
      }
      */
            const expireEndDt = expireEndDtMoment.format('YYYY-MM-DD');

            this.addedProdList.forEach((p) => {
                if (p.centerProductId === centerProductId) {
                    p.expireStartDt = expireStartDt;
                    p.expireEndDt = expireEndDt;
                }
            });
        },

        // centerProductId를 이용해서 periodString과 periodCount를 구하는 함수
        getPeriodInfo(centerProductId) {
            let periodType;
            let periodCount;

            // 이용권과 패키지에 따라서 periodType과 periodCount를 구하는 방법이 구분됨.
            if (this.addedProductType === 'T') {
                periodType = this.addedProdListInfo.periodType;
                periodCount = this.addedProdListInfo.periodCount;
            } else if (this.addedProductType === 'P') {
                const product = this.addedProdListInfo.packageCenterProducts.find(
                    (p) => p.centerProductId === centerProductId
                );
                periodType = product.periodType;
                periodCount = product.periodCount;
            }

            const periodString = periodType === 'M' ? 'month' : 'day';

            return { periodString, periodCount };
        },

        isInfinity(index, p) {
            if (this.prodIsT) {
                // 이용권인 경우
                if (this.addedProdListInfo.lessonCountType === 'U') {
                    return true;
                }

                return false;
            } else if (!this.contractId && this.prodIsP) {
                if (this.addedProdListInfo.packageCenterProducts[index].lessonCountType === 'U') {
                    return true;
                }

                return false;
            } else if (this.contractId && this.prodIsP) {
                if (p.centerProduct.lessonCountType === 'U') {
                    return true;
                }

                return false;
            }
        },

        // 마일리지 설정 정보를 가져오기
        async getMileageInfo() {
            try {
                const { data } = await api.get(`/admin/api/centerMileage/${this.cId}`);
                this.mileageInfo = data;
            } catch (e) {
                console.error(e);
            }
        },

        checkAllowedCount(p, type) {
            if (type === 'W' || type === 'U') {
                this.countMessage = '';
                return;
            }
            if (parseInt(this.$route.query.allowedCount, 10) > p) {
                this.countMessage = '예약되어있는 횟수 보다 낮은 값을 넣을 수 없습니다.';
                return true;
            }
            this.countMessage = '';
            return false;
        },
    },
};
</script>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
<style scoped></style>
